<div class="main-content table-page cc-pagina cc-tablero">
  <div class="container-fluid">
    <header class="table-page__hero cc-tablero__cabecera">
      <div class="table-page__copy">
        <h1>Calidad de código</h1>
        <p>El estado de tus proyectos, en un solo lugar.</p>
      </div>
      <div class="cc-tablero__acciones">
        <div class="cc-tablero__sincronizacion" *ngIf="estado !== 'CARGANDO' && estado !== 'ERROR'">
          <span [ngClass]="estadoSincronizacion.clase">
            <span class="material-icons" aria-hidden="true">{{ estadoSincronizacion.icono }}</span>
            {{ estadoSincronizacion.texto }}
          </span>
          <small>{{ tituloActualizar }}</small>
        </div>
        <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact cc-tablero__actualizar"
                [class.is-actualizando]="actualizando" [disabled]="!puedeActualizar" [attr.aria-busy]="actualizando"
                [title]="tituloActualizar" (click)="actualizar()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          {{ actualizando ? "Actualizando…" : "Actualizar" }}
        </button>
      </div>
    </header>

    <div class="cc-franja" role="alert" [ngClass]="franja.clase" *ngIf="franjaConexion as franja">
      <span class="material-icons" aria-hidden="true">{{ franja.icono }}</span>
      <span><strong>{{ franja.titulo }}</strong> {{ franja.texto }}</span>
      <div class="cc-franja__acciones" *ngIf="franja.reintentar">
        <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                [disabled]="actualizando" (click)="actualizar()">
          {{ actualizando ? "Reintentando…" : "Reintentar" }}
        </button>
      </div>
    </div>

    <!-- Los conteos son globales y llegan del servidor; desactualizado se superpone al resultado del gate. -->
    <ng-container *ngIf="conteos && estado !== 'ERROR' && estado !== 'CARGANDO'">
      <section class="cc-tablero__indicadores" aria-label="Estado general de los proyectos">
        <button type="button" class="cc-tablero__indicador" [disabled]="consultando" (click)="cambiaFiltro('TODOS')">
          <span class="cc-tablero__simbolo is-info"><span class="material-icons" aria-hidden="true">layers</span></span>
          <span class="cc-tablero__balance">
            <span class="cc-tablero__concepto">Proyectos</span>
            <strong class="cc-tablero__total cc-num">{{ conteo('TODOS') }}</strong>
            <span class="cc-tablero__contexto">{{ conteo('SIN_ANALISIS') }} sin análisis</span>
          </span>
          <span class="material-icons cc-tablero__ir" aria-hidden="true">north_east</span>
        </button>
        <button type="button" class="cc-tablero__indicador" [disabled]="consultando" (click)="cambiaFiltro('PASA')">
          <span class="cc-tablero__simbolo is-pasa"><span class="material-icons" aria-hidden="true">check_circle_outline</span></span>
          <span class="cc-tablero__balance">
            <span class="cc-tablero__concepto">Cumplen el Quality Gate</span>
            <strong class="cc-tablero__total cc-num">{{ conteo('PASA') }}</strong>
            <span class="cc-tablero__contexto is-pasa" *ngIf="conteos.todos > 0; else sinPorcentaje">{{ textoPorcentajePasa }} del total</span>
            <ng-template #sinPorcentaje><span class="cc-tablero__contexto">Todavía sin proyectos</span></ng-template>
          </span>
          <span class="cc-tablero__proporcion" aria-hidden="true" *ngIf="conteos.todos > 0"><span [style.width.%]="porcentajePasa"></span></span>
        </button>
        <button type="button" class="cc-tablero__indicador" [disabled]="consultando" (click)="cambiaFiltro('NO_PASA')">
          <span class="cc-tablero__simbolo is-no-pasa"><span class="material-icons" aria-hidden="true">error_outline</span></span>
          <span class="cc-tablero__balance">
            <span class="cc-tablero__concepto">No cumplen el Quality Gate</span>
            <strong class="cc-tablero__total cc-num">{{ conteo('NO_PASA') }}</strong>
            <span class="cc-tablero__contexto" [class.is-no-pasa]="conteos.noPasa > 0">{{ conteos.noPasa > 0 ? 'Requieren revisión' : 'Sin incumplimientos' }}</span>
          </span>
          <span class="material-icons cc-tablero__ir" aria-hidden="true">north_east</span>
        </button>
      </section>
      <div class="cc-tablero__antiguedad" *ngIf="conteos.desactualizados > 0">
        <span class="material-icons" aria-hidden="true">schedule</span>
        <span>{{ conteo('DESACTUALIZADOS') }} {{ conteos.desactualizados === 1 ? 'proyecto tiene un análisis desactualizado' : 'proyectos tienen análisis desactualizados' }}</span>
        <button type="button" class="cc-enlace" [disabled]="consultando" (click)="cambiaFiltro('DESACTUALIZADOS')">
          Ver proyectos <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </ng-container>

    <div class="cc-tablero__contenido" [class.cc-tablero__contenido--con-seleccion]="estado === 'DATOS'">
      <section class="table-page__card cc-tablero__cuerpo" aria-labelledby="cc-tablero-proyectos" [attr.aria-busy]="consultando">
        <div class="cc-tablero__encabezado">
          <h2 id="cc-tablero-proyectos">Proyectos <span class="cc-tablero__cantidad cc-num" *ngIf="conteos">{{ conteo('TODOS') }}</span></h2>
          <span class="cc-tablero__orden">Primero los que no pasan</span>
        </div>
        <div class="table-page__toolbar cc-tablero__barra" *ngIf="estado !== 'ERROR' && estado !== 'CARGANDO'">
          <fieldset class="cc-tablero__filtros" aria-label="Filtrar por estado del Quality Gate">
            <button *ngFor="let f of filtros" type="button" class="cc-tablero__filtro"
                    [class.is-elegido]="f.valor === filtro" [attr.aria-pressed]="f.valor === filtro"
                    [disabled]="consultando" (click)="cambiaFiltro(f.valor)">
              {{ f.texto }} <span class="cc-num">{{ conteo(f.valor) }}</span>
            </button>
          </fieldset>
          <div class="cc-tablero__campos">
            <mat-form-field appearance="outline" class="table-page__field cc-tablero__buscar" subscriptSizing="dynamic">
              <span matIconPrefix class="material-icons cc-tablero__lupa" aria-hidden="true">search</span>
              <input matInput type="search" id="cc-tablero-busqueda" aria-label="Buscar proyecto o clave"
                     placeholder="Buscar proyecto o clave" autocomplete="off" [(ngModel)]="busqueda" (ngModelChange)="cambiaBusqueda()" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="table-page__field cc-tablero__gate" subscriptSizing="dynamic">
              <span matTextPrefix class="cc-tablero__rotulo-gate" aria-hidden="true">Quality Gate</span>
              <mat-select aria-label="Quality Gate" [(ngModel)]="gate" (ngModelChange)="cambiaGate()" [disabled]="consultando">
                <mat-option value="">Cualquiera</mat-option>
                <mat-option *ngFor="let g of gates" [value]="g">{{ g }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <output class="table-page__empty cc-tablero__vacio" *ngIf="estado === 'CARGANDO'">
          <span class="material-icons" aria-hidden="true">hourglass_top</span>
          <h3>Consultando el tablero</h3><p>Espere un momento.</p>
        </output>
        <div class="table-page__empty cc-tablero__vacio" role="alert" *ngIf="estado === 'ERROR'">
          <span class="material-icons" aria-hidden="true">cloud_off</span>
          <h3>No se pudo consultar el tablero</h3><p>{{ error }}</p>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="consultar()">Volver a consultar</button>
        </div>
        <div class="table-page__empty cc-tablero__vacio" *ngIf="estado === 'SIN_CREDENCIAL'">
          <span class="material-icons" aria-hidden="true">vpn_key_off</span>
          <h3>Sin credencial de SonarQube configurada</h3>
          <p>Solicita a quien administra el COS que configure la conexión con SonarQube para consultar los proyectos.</p>
        </div>
        <div class="table-page__empty cc-tablero__vacio" *ngIf="estado === 'VACIO'">
          <span class="material-icons" aria-hidden="true">cloud_off</span>
          <h3>Todavía no hay datos de SonarQube</h3>
          <p>Ninguna sincronización ha guardado una foto. Pide una con «Actualizar» o espera a la tarea programada.</p>
        </div>
        <div class="table-page__empty cc-tablero__vacio" *ngIf="estado === 'SIN_RESULTADOS'">
          <span class="material-icons" aria-hidden="true">filter_alt_off</span>
          <h3>Ningún proyecto coincide con lo que se pidió</h3>
          <p>Revisa el texto de la búsqueda, el gate o el estado elegido.</p>
          <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="quitarFiltros()">Quitar filtros</button>
        </div>

        <ng-container *ngIf="estado === 'DATOS'">
          <div class="table-page__table-wrap cc-tablero__desplazable" [class.cc-atenuado]="consultando" [attr.inert]="consultando ? '' : null">
            <table #lista class="table-page__table cc-tablero__lista" [style.--cc-fila-extra.px]="extraFila">
              <caption class="cc-oculto">Proyectos de SonarQube. Selecciona un proyecto para consultar sus ocho métricas. La tabla muestra cifras de código general.</caption>
              <thead><tr>
                <th scope="col" class="cc-tablero__col-proyecto">Proyecto</th>
                <th scope="col">Quality Gate</th>
                <th scope="col">Seguridad</th>
                <th scope="col">Cobertura</th>
                <th scope="col">Duplicación</th>
              </tr></thead>
              <tbody>
                <tr *ngFor="let f of filasVisibles; trackBy: trackFila" class="cc-tablero__proyecto is-clickable"
                    [ngClass]="f.estado.clase" [class.is-selected]="seleccionada?.id === f.id" (click)="selecciona(f)"
                    (keydown.enter)="abreDesdeFila($event, f)">
                  <td class="cc-tablero__identidad">
                    <button type="button" class="cc-tablero__seleccionar" [id]="'cc-tablero-nombre-' + f.id"
                            [attr.aria-pressed]="seleccionada?.id === f.id" aria-controls="cc-tablero-inspector"
                            (click)="$event.stopPropagation(); selecciona(f)">
                      {{ f.nombre }}
                    </button>
                    <span class="cc-etiqueta" *ngIf="f.etiqueta">{{ f.etiqueta }}</span>
                    <div class="cc-tablero__datos-fila">
                      <span *ngIf="!f.chip" [title]="f.fecha">{{ f.sinAnalisis ? 'Sin análisis' : f.hace }}</span>
                      <span class="cc-marca" [ngClass]="f.chip.clase" [title]="f.chip.titulo" *ngIf="f.chip">
                        <span class="material-icons" aria-hidden="true">{{ f.chip.icono }}</span>{{ f.chip.texto }}
                      </span>
                      <span *ngIf="f.gate" class="cc-tablero__gate-fila">Gate {{ f.gate }}</span>
                      <span class="cc-marca is-info" *ngIf="f.gateCambio" title="Los criterios del Quality Gate cambiaron después de este análisis">
                        <span class="material-icons" aria-hidden="true">published_with_changes</span>Gate cambiado
                      </span>
                    </div>
                  </td>
                  <td><span class="cc-insignia cc-tablero__veredicto" [ngClass]="f.estado.clase">
                    <span class="material-icons" aria-hidden="true">{{ f.estado.icono }}</span>{{ f.estado.texto }}
                  </span></td>
                  <td *ngFor="let indice of [0, 4, 5]">
                    <ng-container *ngIf="f.cifras[indice] as c; else sinDato">
                      <span class="cc-tablero__dato-metrica" [class.cc-falla]="c.falla" [title]="c.titulo">
                        <span class="cc-cal" [ngClass]="c.letraClase" *ngIf="c.icono === 'letra'">{{ c.letra }}</span>
                        <span class="cc-tablero__pista" [ngClass]="c.tonoAnillo" [class.is-falla]="c.falla" aria-hidden="true" *ngIf="indice === 4 && c.anillo !== null">
                          <span [style.width.%]="c.anillo"></span>
                        </span>
                        <span class="cc-num">{{ c.valor }}</span>
                        <span class="material-icons cc-tablero__aviso-metrica" *ngIf="c.falla" aria-hidden="true">error_outline</span>
                        <span class="cc-oculto" *ngIf="c.falla">{{ c.titulo }}</span>
                      </span>
                    </ng-container>
                    <ng-template #sinDato><span aria-label="Sin dato">—</span></ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-page__footer cc-tablero__pie" [attr.inert]="consultando ? '' : null">
            <div class="table-page__meta cc-sec">
              <span>{{ textoRango }}</span><span id="cc-tablero-leyenda">Métricas de código general</span>
            </div>
            <nav class="table-page__pager" aria-label="Páginas de proyectos" *ngIf="paginas > 1">
              <button type="button" class="table-page__pager-link" [disabled]="pagina === 1" (click)="irA(pagina - 1)">Anterior</button>
              <button type="button" class="table-page__pager-page" *ngFor="let n of numerosDePagina" [class.is-current]="n === pagina"
                      [attr.aria-current]="n === pagina ? 'page' : null" [attr.aria-label]="'Página ' + n" (click)="irA(n)">{{ n }}</button>
              <button type="button" class="table-page__pager-link" [disabled]="pagina === paginas" (click)="irA(pagina + 1)">Siguiente</button>
            </nav>
          </div>
        </ng-container>
      </section>

      <!-- Seleccionar no navega ni consulta de nuevo: las ocho métricas ya están en la respuesta del tablero. -->
      <ng-container *ngIf="estado === 'DATOS'">
        <aside class="table-page__card cc-tablero__detalle" id="cc-tablero-inspector" aria-labelledby="cc-tablero-seleccion"
               [attr.aria-busy]="consultando" [class.cc-atenuado]="consultando" [attr.inert]="consultando ? '' : null" *ngIf="seleccionada as f">
          <div class="cc-tablero__introduccion">
            <p class="cc-tablero__eyebrow">Proyecto seleccionado</p>
            <div class="cc-tablero__titular">
              <h2 id="cc-tablero-seleccion">{{ f.nombre }}</h2>
              <span class="cc-insignia" [ngClass]="f.estado.clase"><span class="material-icons" aria-hidden="true">{{ f.estado.icono }}</span>{{ f.estado.texto }}</span>
            </div>
            <span class="cc-etiqueta" *ngIf="f.etiqueta">{{ f.etiqueta }}</span>
            <div class="cc-tablero__datos">
              <p><span *ngIf="f.gate">Gate {{ f.gate }}</span><span *ngIf="f.lineas" [title]="f.lineasTitulo">{{ f.lineas }} líneas de código</span></p>
              <p *ngIf="!f.sinAnalisis">Último análisis: {{ f.fecha }} <span *ngIf="!f.chip">({{ f.hace }})</span></p>
              <span class="cc-marca" [ngClass]="f.chip.clase" [title]="f.chip.titulo" *ngIf="f.chip">
                <span class="material-icons" aria-hidden="true">{{ f.chip.icono }}</span>{{ f.chip.texto }}
              </span>
              <span class="cc-marca is-info" *ngIf="f.gateCambio" title="Los criterios del Quality Gate cambiaron después de este análisis">
                <span class="material-icons" aria-hidden="true">published_with_changes</span>Gate cambiado
              </span>
            </div>
          </div>
          <p class="cc-tablero__criterios" [ngClass]="f.estado.clase" *ngIf="f.criteriosTexto && !f.sinAnalisis">
            <span class="material-icons" aria-hidden="true">{{ f.estado.icono }}</span>
            <span><strong>{{ f.criteriosTexto }}</strong><span>Criterios del Quality Gate</span></span>
          </p>
          <p class="cc-tablero__nota-cal" *ngIf="f.notaClasica"><span class="material-icons" aria-hidden="true">info</span>{{ f.notaClasica }}</p>
          <p class="cc-tablero__nota" *ngIf="f.sinCodigoNuevo && !f.sinAnalisis">El último análisis no trae código nuevo.</p>
          <ng-container *ngIf="!f.sinAnalisis; else proyectoSinAnalisis">
            <table class="cc-tablero__metricas">
              <caption class="cc-oculto">Métricas de {{ f.nombre }}: código general y código nuevo.</caption>
              <thead><tr><th scope="col">Métrica</th><th scope="col">General</th><th scope="col">Código nuevo</th></tr></thead>
              <tbody>
                <tr class="cc-tablero__cifra" *ngFor="let c of f.cifras; trackBy: trackCifra" [class.is-falla]="c.falla || c.fallaNuevo">
                  <th scope="row" class="cc-tablero__rotulo">
                    {{ c.rotulo }}<svg class="cc-tablero__senal" viewBox="0 0 6 6" role="img" [attr.aria-label]="c.motivo" *ngIf="c.motivo"><title>{{ c.motivo }}</title><circle cx="3" cy="3" r="3"></circle></svg>
                  </th>
                  <td class="cc-tablero__valor" [class.cc-falla]="c.falla" [title]="c.titulo">
                    <span class="cc-tablero__numero"><span class="cc-cal" [ngClass]="c.letraClase" *ngIf="c.icono === 'letra'">{{ c.letra }}</span><span class="cc-num">{{ c.valor }}</span></span>
                  </td>
                  <td class="cc-tablero__nuevo" [class.cc-falla]="c.fallaNuevo" [title]="c.tituloNuevo">
                    <span class="cc-tablero__numero"><span class="cc-cal is-chica" [ngClass]="c.nuevoLetraClase" *ngIf="c.nuevoLetra">{{ c.nuevoLetra }}</span><span class="cc-num">{{ c.nuevo || '—' }}</span></span>
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="cc-tablero__leyenda">El código nuevo corresponde al periodo definido en SonarQube.</p>
          </ng-container>
          <ng-template #proyectoSinAnalisis>
            <div class="cc-tablero__sin-analisis"><span class="material-icons" aria-hidden="true">analytics</span><h3>Sin análisis todavía</h3><p>El proyecto está dado de alta en SonarQube, pero ningún pipeline lo ha analizado.</p></div>
          </ng-template>
          <div class="cc-tablero__salidas">
            <a class="cc-enlace cc-tablero__abrir" [routerLink]="[rutaProyecto, f.id]" [state]="vuelta">
              Ver detalle del proyecto <span class="material-icons" aria-hidden="true">arrow_forward</span>
            </a>
            <div class="cc-tablero__botones">
              <a class="app-form-btn app-form-btn--secondary app-form-btn--compact cc-tablero__boton" [href]="f.enlaceSonar" target="_blank" rel="noopener"
                 aria-label="Abrir en SonarQube" aria-describedby="cc-tablero-seleccion" title="Abrir en SonarQube">
                <app-icono-cc nombre="sonar"></app-icono-cc><span>Abrir en SonarQube</span>
              </a>
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cc-tablero__boton"
                      aria-label="Reporte PDF del proyecto" aria-describedby="cc-tablero-seleccion" [title]="tituloPdf(f)"
                      [disabled]="f.sinAnalisis || (emitiendo != null && emitiendo !== f.id)" [class.is-emitiendo]="emitiendo === f.id"
                      [attr.aria-disabled]="emitiendo === f.id ? 'true' : null" [attr.aria-busy]="emitiendo === f.id" (click)="pdf(f)">
                <app-icono-cc [nombre]="emitiendo === f.id ? 'girando' : 'pdf'"></app-icono-cc><span>{{ emitiendo === f.id ? 'Generando PDF…' : 'Descargar PDF' }}</span>
              </button>
            </div>
          </div>
        </aside>
      </ng-container>
    </div>
    <output class="cc-oculto" aria-live="polite">{{ seleccionada ? 'Proyecto seleccionado: ' + seleccionada.nombre : '' }}</output>
  </div>
</div>
